export const EDIT_FORM = 'EDIT_FORM';
export const TOGGLE_COMMANDS_VIEW = 'TOGGLE_COMMANDS_VIEW';
export const INITIALIZE_FORM_STATE = 'INITIALIZE_FORM_STATE';
export const SUBMIT_ATTEMPTED = 'SUBMIT_ATTEMPTED';
export const SET_RUN_IN_DOCKER = 'SET_RUN_IN_DOCKER';
export const SET_RUN_ON_SHARED_HARDWARE = 'SET_RUN_ON_SHARED_HARDWARE';
export const SET_COMMANDS = 'SET_COMMANDS';
